import { createStore } from 'vuex'
import QS from 'qs'
import commonVal from '../components/common'

export default createStore({
  modules: {
	index: {
		state: {
		  indexQueryVo: {}
		},
		mutations: {
		  mutIndexQueryVo (state, data) {
			  state.indexQueryVo = data
		  }
		},
		actions: {
		  actIndexLoads (context) {
			  fetch(`${commonVal.requestUrl}/api/index/`)
			  .then(res => res.json())
				.then(res => {
					
					context.commit('mutIndexQueryVo', res.data)
					
					console.log(context.getters.indexqueryvo)
					
				})
		  }
		},
		getters: {
		  indexqueryvo (state) {
			  return state.indexQueryVo
		  }
		}
	},
	filmlist: {
		state: {
			filmQueryVo: {}
		},
		mutations: {
			mutFilmQueryVo (state, data) {
				state.filmQueryVo = data
			}
		},
		actions: {
			actFilmloads (context, data) {
				// console.log(`${commonVal.requestUrl}/api/films/?${QS.stringify(data.payload)}`)
				fetch(`${commonVal.requestUrl}/api/films/?${QS.stringify(data.payload)}`)
				.then(res => res.json())
				.then(res => {
					context.commit('mutFilmQueryVo', res.data)
					console.log(res.data)
				})
			}
		},
		getters: {
			filmqueryvo (state) {
				return state.filmQueryVo
			}
		}
	},
	filmdetail: {
		state: {
			film: null
		},
		mutations: {
		    mutFilm (state, data) {
				state.film = data
		    }
		},
		actions: {
		    actFilmload (context, data) {
			    fetch(`${commonVal.requestUrl}/api/films/model/?filmId=${data.payload}`)
			    .then(res => res.json())
			    .then(res => {
				  context.commit('mutFilm', res.data)
				  console.log(context.getters.filmdetail)
				  
				 
			  })
		    }
		},
		getters: {
		    filmdetail (state) {
			  return state.film
		    }
		}
	},
	cinemalist: {
		state: {
			cinemaQueryVo: {},
		},
		mutations: {
			mutCinemaQueryVo (state, data) {
				state.cinemaQueryVo = data
			}
		},
		actions: {
			actCinemaLoad (context, data) {
				return new Promise((resolve,reject) => {
					fetch(`${commonVal.requestUrl}/api/cinemas/?${QS.stringify(data.payload)}`)
					.then(res => res.json())
					.then(res => {
						context.commit('mutCinemaQueryVo',res.data)
						console.log(context.getters.cinemaqueryvo)
						resolve()
					})
				})
				
			}
		},
		getters: {
			cinemaqueryvo (state) {
				return state.cinemaQueryVo
			}
		}
	},
	cinemadetail: {
		state: {
			cinema: null	

		},
		mutations: {
			mutCinema (state, data) {
				state.cinema = data
			}
		},
		actions: {
			
			actCinemaDetailLoad (context, data) {
				return new Promise((resolve,reject) => {
					fetch(`${commonVal.requestUrl}/api/cinemas/model/?cinemaId=${data.payload}`,{
						method: 'GET',
						headers: {
							'Content-Type':'application/x-www-form-urlencoded'
						}
					})
					.then(res => res.json())
					.then(res => {
				
						context.commit('mutCinema', res.data)
						console.log(context.getters.cinemadetail)
						resolve()
					})
				})
				
			}
			
		},
		getters: {
			cinemadetail (state) {
				return state.cinema
			}
		}
	},
	watchtimedetail: {
		state: {
			watchTimeQueryVo: {}
		},
		mutations: {
			mutWatchTimeQueryVo (state, data) {
				state.watchTimeQueryVo = data
			}
		},
		actions: {
			actWatchTimeLoad (context, data) {
				fetch(`${commonVal.requestUrl}/api/watchs/model/?${QS.stringify(data.payload)}`)
				.then(res => res.json())
				.then(res => {
					context.commit('mutWatchTimeQueryVo', res.data)
					console.log(context.getters.watchtime)
				})
			}
		},
		getters: {
			watchtime (state) {
				return state.watchTimeQueryVo
			}
		}
	}
  }
})
